<template>
  <div style="height: 100%">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align: center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
      <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
      </tr>-->
      <Form label-position="left" :label-width="100" style="margin-left: 20px">
        <FormItem label="展示数据">
          <Tag
            v-for="item in columnsbackup"
            :name="item.title"
            @on-change="changeColumn"
            size="medium"
            checkable
            color="primary"
            >{{ item.title }}</Tag
          >
        </FormItem>
      </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>

    <div class="aside-big">
      <div class="aside-container">
        <div class="aside-content">
          <Input
            v-model="userAddressSearch"
            @on-change="changeSearch"
            placeholder="快速搜索"
          />
          <Tree
            show-checkbox
            ref="tree"
            :render="renderContent"
            :check-strictly="true"
            :data="amendTreeData"
            @on-check-change="changeCheck"
          ></Tree>
        </div>
      </div>
    </div>
    <div class="home-container" style="margin-left: 300px">
      <div class="home-content">
        <div style="height: 10%">
          <DatePicker
            format="yyyy-MM-dd"
            v-model="modalData.timeRange[0]"
            type="date"
            split-panels
            placeholder="选择开始时间"
            style="width: 24%"
          ></DatePicker>
          <!-- <Select v-model="modalData.hourRange[0]" style="width:6%">
            <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
          </Select>-->
          <DatePicker
            format="yyyy-MM-dd"
            v-model="modalData.timeRange[1]"
            type="date"
            split-panels
            placeholder="选择结束时间"
            style="width: 24%; margin-left: 20px"
          ></DatePicker>
          <!-- <Select v-model="modalData.hourRange[1]" style="width:6%">
            <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
          </Select>-->
          <!-- <Select v-model="modalData.timeSelect" style="width:6%;margin-left: 20px;">
            <Option
              v-for="item in selectList"
              :value="item.value"
              :key="item.value"
            >{{ item.label }}</Option>
          </Select>-->
          <!-- <Select v-model="selectMeterType" style="width:100px;margin-left: 20px;">
            <Option v-for="item in meterTList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>-->
          <!-- <Button type="primary" @click="ok" :loading="okLoading" style="margin-left: 20px;">检索</Button> -->
          <Button
            type="primary"
            @click="isShowSetModal = true"
            style="margin-left: 20px; float: right"
            >显示项设置</Button
          >
        </div>
        <div style="height: 75%">
          <Table
            :height="tableHeight"
            :columns="columns"
            :data="tableData"
            border
            highlight-row
          ></Table>
        </div>
        <div style="height: 15%">
          <Row>
            <Col span="8">
              <Icon type="ios-grid" size="30" />
              <span class="sum-title">居民小区：</span>
              <span class="sum-value">{{ countMenu.xiaoquCount }}</span>
            </Col>
            <!-- <Col span="6">
              <Icon type="ios-home" size="30" />
              <span class="sum-title">楼栋：</span>
              <span class="sum-value">{{countMenu.buildingCount}}</span>
            </Col>-->
            <Col span="8">
              <Icon type="ios-person" size="30" />
              <span class="sum-title">居民用户：</span>
              <span class="sum-value">{{ countMenu.personCount }}</span>
            </Col>
            <Col span="8">
              <Icon type="ios-pulse-outline" size="30" />
              <span class="sum-title">居民表具：</span>
              <span class="sum-value">{{ countMenu.personTableCount }}</span>
            </Col>
          </Row>
          <Row style="margin-top: 5px">
            <Col span="8">
              <Icon type="ios-people" size="30" />
              <span class="sum-title">企业用户：</span>
              <span class="sum-value">{{ countMenu.companyCount }}</span>
            </Col>
            <Col span="8">
              <Icon type="ios-pulse-outline" size="30" />
              <span class="sum-title">企业表具：</span>
              <span class="sum-value">{{ countMenu.companyTableCount }}</span>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <!--Modal v-model="showModal" title="检索条件">
      <Form :model="modalData" label-position="left" :label-width="100">
        <FormItem label="开始时间">
          <DatePicker format="yyyy-MM-dd HH点" v-model="modalData.timeRange[0]" type="datetime" split-panels placeholder="选择时间(精确到小时)"
            style="width: 350px"></DatePicker>
        </FormItem>
        <FormItem label="结束时间">
          <DatePicker format="yyyy-MM-dd HH点" v-model="modalData.timeRange[1]" type="datetime" split-panels placeholder="选择时间(精确到小时)"
            style="width: 350px"></DatePicker>
        </FormItem>
        <FormItem label="时间间隔">
          <Select v-model="modalData.timeSelect" style="width:350px">
            <Option v-for="item in selectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long @click="ok" :loading="okLoading">检索</Button>
      </div>
    </Modal-->
  </div>
</template>

<script>
export default {
  name: "home",
  watch: {
    selectMeterType(newValue, oldValue) {
      let that = this;
      that.columns = that.columnsList[newValue];
    },
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", function () {
      that.tableHeight = (window.innerHeight - 186) * 0.8;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.8;

    var cs = [];
    if (localStorage.getItem("userMeterType") == 0) {
      cs = [
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 250,
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 160,
        },
        {
          title: "表具地址",
          key: "messageAddress",
          resizable: true,
          width: 160,
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 100,
        },
        {
          title: "上报时间",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.messageTimestamp.split(":")[0] +
                  ":" +
                  params.row.messageTimestamp.split(":")[1]
              ),
            ]);
          },
          resizable: true,
          width: 200,
        },
        // {
        //   title: "统计时间",
        //   key: "date_search",
        //   resizable: true,
        //   width: 200
        // },
        {
          title: "正向流量值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.正向流量值 + " m³"
              ),
            ]);
          },
        },
        {
          title: "正向流量间隔值",
          resizable: true,
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.正向流量间隔值 + " m³"
              ),
            ]);
          },
        },
        {
          title: "反向流量值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.反向流量值 + " m³"
              ),
            ]);
          },
        },
        {
          title: "反向流量间隔值",
          resizable: true,
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.反向流量间隔值 + " m³"
              ),
            ]);
          },
        },
      ];
    }

    if (localStorage.getItem("userMeterType") == 1) {
      cs = [
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 250,
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 100,
        },
        {
          title: "表具地址",
          key: "messageAddress",
          resizable: true,
          width: 160,
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 100,
        },
        {
          title: "上报时间",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.messageTimestamp.split(":")[0] +
                  ":" +
                  params.row.messageTimestamp.split(":")[1]
              ),
            ]);
          },
          resizable: true,
          width: 200,
        },
        // {
        //   title: "统计时间",
        //   key: "date_search",
        //   resizable: true,
        //   width: 200
        // },
        {
          title: "热量值",
          key: "热量值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.热量值 + " kwh"
              ),
            ]);
          },
        },
        {
          title: "热量间隔值",
          key: "热量间隔值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.热量间隔值 + " kwh"
              ),
            ]);
          },
        },
        {
          title: "冷量值",
          key: "冷量值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.冷量值 + " kwh"
              ),
            ]);
          },
        },
        {
          title: "冷量间隔值",
          key: "冷量间隔值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.冷量间隔值 + " kwh"
              ),
            ]);
          },
        },
        {
          title: "流量值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.正向流量值 + " m³"
              ),
            ]);
          },
        },
        {
          title: "流量间隔值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.正向流量间隔值 + " m³"
              ),
            ]);
          },
        },
      ];
    }

    if (localStorage.getItem("userMeterType") == 5) {
      cs = [
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 250,
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 100,
        },
        {
          title: "表具地址",
          key: "messageAddress",
          resizable: true,
          width: 160,
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 100,
        },
        {
          title: "上报时间",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.messageTimestamp.split(":")[0] +
                  ":" +
                  params.row.messageTimestamp.split(":")[1]
              ),
            ]);
          },
          resizable: true,
          width: 200,
        },
        // {
        //   title: "统计时间",
        //   key: "date_search",
        //   resizable: true,
        //   width: 200
        // },
        {
          title: "流量值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.正向流量值 + " m³"
              ),
            ]);
          },
        },
        {
          title: "流量间隔值",
          resizable: true,
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {},
                  style: {},
                  on: {},
                },
                params.row.正向流量间隔值 + " m³"
              ),
            ]);
          },
        },
      ];
    }

    that.columns = cs;
    that.columnsbackup = cs;

    that.getAddressEnum();
    that.getMeterDetailedList();
    that.generateColumnTitleArray();
    let tempDate = new Date();
    that.modalData.timeRange[0] =
      global.dateFtt(
        "yyyy-MM-dd",
        new Date(tempDate.getTime() - 1000 * 60 * 60 * 24 * 3)
      ) + " 00:00:00";
    that.modalData.timeRange[1] =
      global.dateFtt("yyyy-MM-dd hh:mm:ss", tempDate) + " 23:59:59";
    // that.selectMeterType = localStorage.getItem('userMeterType');
  },
  data() {
    return {
      userAddressSearch: "",
      pageName: "home",
      isShowSetModal: false,
      selectMeterType: 0,
      okLoading: false,
      checkId: "",
      meterType: "",
      checkArr: [],
      tableHeight: "200",
      showModal: false,
      hourList: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
      ],
      meterTList: [
        {
          value: 0,
          label: "水表",
        },
        {
          value: 1,
          label: "热表",
        },
        {
          value: 2,
          label: "流量表",
        },
      ],
      userMeterTypeEnum: {
        0: "水表",
        5: "流量计",
        1: "热量表",
        2: "动态平衡阀",
        3: "消防栓",
        4: "压力开关、流量开关",
      },
      selectList: [
        {
          value: "hour",
          label: "1小时",
        },
        {
          value: "day",
          label: "1天",
        },
        {
          value: "month",
          label: "1月",
        },
        {
          value: "year",
          label: "1年",
        },
      ],
      modalData: {
        timeRange: ["2020-01-15", "2020-01-15"],
        hourRange: ["0", "24"],
        timeSelect: "hour",
      },
      amendTreeData: [],
      qiyeUserBackup: [],
      columns: [],
      showColumnTitleArray: [],
      columnsbackup: [
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 250,
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 100,
        },
        {
          title: "表具地址",
          key: "messageAddress",
          resizable: true,
          width: 160,
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 100,
        },
        {
          title: "上报时间",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.messageTimestamp.split(":")[0] +
                  ":" +
                  params.row.messageTimestamp.split(":")[1]
              ),
            ]);
          },
          resizable: true,
          width: 200,
        },
        // {
        //   title: "统计时间",
        //   key: "date_search",
        //   resizable: true,
        //   width: 200
        // },
        {
          title: "正向流量值(L)",
          key: "正向流量值",
          resizable: true,
          width: 160,
        },
        {
          title: "正向流量间隔值(L)",
          key: "正向流量间隔值",
          resizable: true,
          width: 200,
        },
        {
          title: "反向流量值(L)",
          key: "反向流量值",
          resizable: true,
          width: 160,
        },
        {
          title: "反向流量间隔值(L)",
          key: "反向流量间隔值",
          resizable: true,
          width: 200,
        },
      ],
      columnsList: [
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 250,
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 100,
        },
        {
          title: "表具地址",
          key: "messageAddress",
          resizable: true,
          width: 160,
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 100,
        },
        {
          title: "上报时间",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.messageTimestamp.split(":")[0] +
                  ":" +
                  params.row.messageTimestamp.split(":")[1]
              ),
            ]);
          },
          resizable: true,
          width: 200,
        },
        // {
        //   title: "统计时间",
        //   key: "date_search",
        //   resizable: true,
        //   width: 200
        // },
        {
          title: "正向流量值(L)",
          key: "正向流量值",
          resizable: true,
          width: 160,
        },
        {
          title: "正向流量间隔值(L)",
          key: "正向流量间隔值",
          resizable: true,
          width: 200,
        },
        {
          title: "反向流量值(L)",
          key: "反向流量值",
          resizable: true,
          width: 160,
        },
        {
          title: "反向流量间隔值(L)",
          key: "反向流量间隔值",
          resizable: true,
          width: 200,
        },
      ],
      tableData: [],
      meterInfo: {},
      meterAddressName: {},
      countMenu: {
        xiaoquCount: 0,
        buildingCount: 0,
        personCount: 0,
        personTableCount: 0,
        companyCount: 0,
        companyTableCount: 0,
      },
    };
  },
  methods: {
    getAddressEnum() {
      var that = this;
      that.$axios
        .post("/api/dictionary/selectAddressEnum", {})
        .then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.addressObject = data.body;
        })
        .catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error,
          });
          console.log(error);
        })
        .finally(() => {});
    },
    getMeterDetailedList() {
      
      var that = this;

      var searchParam = {
        userAccount: localStorage.getItem("userAccount"),
      };
      var searchMeterType = global.searchMeterType();
      if (searchMeterType != undefined) {
        searchParam.meterType = searchMeterType;
      }

      that.$axios
        .post("/api/meterdetailed/getMeterDetailedList", searchParam)
        .then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.meterAddressName = {};
          that.amendTreeData = [
            {
              id: 1,
              title: '居民用户',
              expand: true,
              disableCheckbox: true,
              children:[]
            },
            {
              id: 2,
              title: "企业用户",
              expand: true,
              disableCheckbox: true,
              children: [],
            },
          ];
          that.countMenu = {
            xiaoquCount: 0,
            buildingCount: 0,
            personCount: 0,
            personTableCount: 0,
            companyCount: 0,
            companyTableCount: 0,
          };

          let meterAddressArray = [];
          console.log(that.amendTreeData,123);
          data.body.forEach((item) => {
            let indexList = [0];
            item.id = item.meterAddress;
            item.title = item.meterAddress;
            let addressNameTemp = "";
            for (let i = 1; i <= 10; i++) {
              if (item["addressfield" + i + "Name"]) {
                addressNameTemp =
                  (addressNameTemp == "" ? "" : addressNameTemp + "-") +
                  item["addressfield" + i + "Name"];
              }
            }
            that.meterAddressName[item.meterAddress] = addressNameTemp;
            that.meterInfo[item.meterAddress] = item;
            // if(item.addressRemark1 == "居民用户"){

            if (item.addressRemark1 == "居民用户") {
              // 居民用户
              that.countMenu.personCount++;
              that.countMenu.personTableCount++;
              if (item["addressfield1Name"]) {
                if (item["addressfield2Name"]) {
                  that.countMenu.buildingCount++;
                }

                if (item["addressfield3Name"]) {
                  that.countMenu.xiaoquCount++;
                }
              }
              item.title =
                  (item.addressfield1Name == null
                    ? ""
                    : item.addressfield1Name) +
                  (item.addressfield2Name == null
                    ? ""
                    : "" + item.addressfield2Name) +
                  (item.addressfield3Name == null
                    ? ""
                    : "" + item.addressfield3Name) +
                  (item.addressfield4Name == null
                    ? ""
                    : "" + item.addressfield4Name) +
                  (item.addressfield5Name == null
                    ? " "
                    : "" + item.addressfield5Name);
              that.amendTreeData[0].children.push(item);
              that.qiyeUserBackup.push(item);
            }

            if (false) {
              // 居民用户
              that.countMenu.personCount++;
              that.countMenu.personTableCount++;
              if (item["addressfield1Name"]) {
                let temp1 = that.amendTreeData[0].children;
                let indexR = that.getIndex(temp1, item, 1);
                if (indexR == -1) {
                  temp1.push({
                    id: item["addressfield" + 1],
                    title: item["addressfield" + 1 + "Name"],
                    expand: true,
                    disableCheckbox: true,
                    children: [],
                  });
                  indexR = temp1.length - 1;
                }
                indexList.push(indexR);

                let temp2 =
                  that.amendTreeData[0].children[indexList[1]].children;
                if (item["addressfield2Name"]) {
                  let indexR = that.getIndex(temp2, item, 2);
                  if (indexR == -1) {
                    temp2.push({
                      id: item["addressfield" + 2],
                      title: item["addressfield" + 2 + "Name"],
                      expand: true,
                      disableCheckbox: true,
                      children: [],
                    });

                    //temp2 push 小区
                    that.countMenu.buildingCount++;
                    indexR = temp2.length - 1;
                  }
                  indexList.push(indexR);

                  let temp3 =
                    that.amendTreeData[0].children[indexList[1]].children[
                      indexList[2]
                    ].children;
                  if (item["addressfield3Name"]) {
                    let indexR = that.getIndex(temp3, item, 3);
                    if (indexR == -1) {
                      temp3.push({
                        id: item["addressfield" + 3],
                        title: item["addressfield" + 3 + "Name"],
                        expand: true,
                        disableCheckbox: true,
                        children: [],
                      });
                      //temp3 push 楼栋
                      that.countMenu.xiaoquCount++;
                      indexR = temp3.length - 1;
                    }
                    indexList.push(indexR);

                    let temp4 =
                      that.amendTreeData[0].children[indexList[1]].children[
                        indexList[2]
                      ].children[indexList[3]].children;
                    if (item["addressfield4Name"]) {
                      let indexR = that.getIndex(temp4, item, 4);
                      if (indexR == -1) {
                        temp4.push({
                          id: item["addressfield" + 4],
                          title: item["addressfield" + 4 + "Name"],
                          expand: true,
                          disableCheckbox: true,
                          children: [],
                        });
                        indexR = temp4.length - 1;
                      }
                      indexList.push(indexR);

                      let temp5 =
                        that.amendTreeData[0].children[indexList[1]].children[
                          indexList[2]
                        ].children[indexList[3]].children[indexList[4]]
                          .children;
                      if (item["addressfield5Name"]) {
                        let indexR = that.getIndex(temp5, item, 5);
                        if (indexR == -1) {
                          temp5.push({
                            id: item["addressfield" + 5],
                            title: item["addressfield" + 5 + "Name"],
                            expand: true,
                            disableCheckbox: true,
                            children: [],
                          });
                          indexR = temp5.length - 1;
                        }
                        indexList.push(indexR);

                        let temp6 =
                          that.amendTreeData[0].children[indexList[1]].children[
                            indexList[2]
                          ].children[indexList[3]].children[indexList[4]]
                            .children[indexList[5]].children;
                        // if(item["addressfield6Name"]){
                        //   let indexR = that.getIndex(temp6,item,6);
                        //   if(indexR == -1){
                        //     temp6.push({
                        //       id: item["addressfield" + 6],
                        //       title: item["addressfield"+ 6 +"Name"],
                        //       expand: true,
                        //       disableCheckbox: true,
                        //       children:[]
                        //     })
                        //     indexR = temp6.length - 1;
                        //   }
                        //   indexList.push(indexR);
                        // }else{
                        //   temp6.push(item);
                        // }
                        temp6.push(item);
                      } else {
                        temp5.push(item);
                      }
                    } else {
                      temp4.push(item);
                    }
                  } else {
                    temp3.push(item);
                  }
                } else {
                  temp2.push(item);
                }
              }
            } else if (item.addressRemark1 == "企业用户") {
              // 企业用户
              that.countMenu.companyCount++;
              that.countMenu.companyTableCount++;
              // that.amendTreeData[1].children.push(item);
              
              if (meterAddressArray.indexOf(item.meterAddress) == -1) {
                item.title =
                  (item.addressfield1Name == null
                    ? ""
                    : item.addressfield1Name) +
                  (item.addressfield2Name == null
                    ? ""
                    : "" + item.addressfield2Name) +
                  (item.addressfield3Name == null
                    ? ""
                    : "" + item.addressfield3Name) +
                  (item.addressfield4Name == null
                    ? ""
                    : "" + item.addressfield4Name) +
                  (item.addressfield5Name == null
                    ? " "
                    : "" + item.addressfield5Name);
                that.amendTreeData[1].children.push(item);
                that.qiyeUserBackup.push(item);
                console.log(item);
                meterAddressArray.push(item.meterAddress);
              }
            }
          });
          
        })
        .catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error,
          });
          console.log(error);
        })
        .finally(() => {});
    },
    changeSearch() {
      this.amendTreeData[0].children = [];
      for (let i = 0; i < this.qiyeUserBackup.length; i++) {
        if (this.qiyeUserBackup[i].title.indexOf(this.userAddressSearch) > -1) {
          this.amendTreeData[0].children.push(this.qiyeUserBackup[i]);
        }
      }
    },
    getIndex(array, object, level) {
      let indexR = -1;
      array.forEach((item, index) => {
        if (item.id == object["addressfield" + level]) {
          indexR = index;
        }
      });
      return indexR;
    },
    changeColumn(checked, name) {
      if (checked) {
        this.showColumnTitleArray.push(name);
      } else {
        this.showColumnTitleArray.splice(
          this.showColumnTitleArray.indexOf(name),
          1
        );
      }

      var showArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        let currentObject = this.columnsbackup[i];
        if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
          showArray.push(currentObject);
        }
      }

      localStorage.setItem(
        this.pageName +
          localStorage.getItem("userAccount") +
          localStorage.getItem("userMeterType"),
        JSON.stringify(this.showColumnTitleArray)
      );

      this.columns = showArray;
    },
    generateColumnTitleArray() {
      let titleArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        titleArray.push(this.columnsbackup[i].title);
      }

      this.showColumnTitleArray = titleArray;
      console.log(this.showColumnTitleArray);

      if (
        localStorage.getItem(
          this.pageName +
            localStorage.getItem("userAccount") +
            localStorage.getItem("userMeterType")
        ) != undefined
      ) {
        this.showColumnTitleArray = JSON.parse(
          localStorage.getItem(
            this.pageName +
              localStorage.getItem("userAccount") +
              localStorage.getItem("userMeterType")
          )
        );
        var showArray = [];
        for (let i = 0; i < this.columnsbackup.length; i++) {
          let currentObject = this.columnsbackup[i];
          if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
            showArray.push(currentObject);
          }
        }

        this.columns = showArray;
      }
    },
    ok() {
      let time = 0;
      // switch (this.modalData.timeSelect) {
      //   case "hour":
      //     time = 1000 * 60 * 60 * 24;
      //     break;
      //   case "day":
      //     time = 1000 * 60 * 60 * 24 * 31;
      //     break;
      //   case "month":
      //     time = 1000 * 60 * 60 * 24 * 365;
      //     break;
      //   case "year":
      //     time = 1000 * 60 * 60 * 24 * 365 * 30;
      //     break;
      //   default:
      //     break;
      // }
      let resultList = [];
      if (
        this.modalData.timeRange[0] &&
        this.modalData.timeRange[1]
        // &&
        // this.modalData.hourRange[0] &&
        // this.modalData.hourRange[1]
      ) {
        let dateStart = new Date(
          global.dateFtt("yyyy-MM-dd", new Date(this.modalData.timeRange[0])) +
            " 00:00:00"
        );
        // dateStart.setHours(this.modalData.hourRange[0] * 1);
        let dateEnd = new Date(
          global.dateFtt("yyyy-MM-dd", new Date(this.modalData.timeRange[1])) +
            " 00:00:00"
        );
        // dateEnd.setHours(this.modalData.hourRange[1] * 1);
        console.log(dateStart);
        console.log(dateEnd);
        //let dateStart = new Date(global.dateFtt("yyyy-MM-dd hh", this.modalData.timeRange[0]) + ':00:00');
        //let dateEnd = new Date(global.dateFtt("yyyy-MM-dd hh", this.modalData.timeRange[1]) + ':00:00');
        if (dateEnd.getTime() - dateStart.getTime() > time && false) {
          this.$Notice.warning({
            title: "选择时间范围过大！",
          });
        } else if (dateEnd.getTime() - dateStart.getTime() <= 0) {
          this.$Notice.warning({
            title: "开始时间必须小于结束时间！",
          });
        } else {
          // let tempDate;
          // switch (this.modalData.timeSelect) {
          //   case "hour":
          //     tempDate = dateStart;
          //     while (tempDate <= dateEnd) {
          //       resultList.push(new Date(tempDate));
          //       tempDate.setHours(tempDate.getHours() + 1);
          //     }
          //     break;
          //   case "day":
          //     dateStart = new Date(
          //       global.dateFtt("yyyy-MM-dd", this.modalData.timeRange[0]) +
          //         " 00:00:00"
          //     );
          //     dateEnd = new Date(
          //       global.dateFtt("yyyy-MM-dd", this.modalData.timeRange[1]) +
          //         " 00:00:00"
          //     );
          //     tempDate = dateStart;
          //     while (tempDate <= dateEnd) {
          //       resultList.push(new Date(tempDate));
          //       tempDate.setDate(tempDate.getDate() + 1);
          //     }
          //     break;
          //   case "month":
          //     dateStart = new Date(
          //       global.dateFtt("yyyy-MM", this.modalData.timeRange[0]) +
          //         "-01 00:00:00"
          //     );
          //     dateEnd = new Date(
          //       global.dateFtt("yyyy-MM", this.modalData.timeRange[1]) +
          //         "-01 00:00:00"
          //     );
          //     tempDate = dateStart;
          //     while (tempDate <= dateEnd) {
          //       resultList.push(new Date(tempDate));
          //       tempDate.setMonth(tempDate.getMonth() + 1);
          //     }
          //     break;
          //   case "year":
          //     dateStart = new Date(
          //       global.dateFtt("yyyy", this.modalData.timeRange[0]) +
          //         "-01-01 00:00:00"
          //     );
          //     dateEnd = new Date(
          //       global.dateFtt("yyyy", this.modalData.timeRange[1]) +
          //         "-01-01 00:00:00"
          //     );
          //     tempDate = dateStart;
          //     while (tempDate <= dateEnd) {
          //       resultList.push(new Date(tempDate));
          //       tempDate.setFullYear(tempDate.getFullYear() + 1);
          //     }
          //     break;
          //   default:
          //     break;
          // }
          if (this.checkId) {
            this.okLoading = true;
            let that = this;
            that.tableData = [];
            let mArray = [];
            mArray.push(that.checkId);
            that.$axios
              .post(
                //   "/api/message/countList", {
                //   address: that.checkId,
                //   dateList: resultList
                // }
                "/api/warn/selectWarn",
                {
                  searchType: 3,
                  startDate: dateStart,
                  meterArray: mArray,
                  endDate: dateEnd,
                  meterAddress: that.checkId,
                }
              )
              .then((data) => {
                if (data.errorCode != 0) {
                  that.$Notice.error({
                    title: "异常",
                    desc: data.errorInfo,
                  });
                  return;
                }
                let lastContent = null;
                let nextContent = null;
                let lastId = null;
                that.tableData = [];
                data.body.map(function (item, index, arr) {
                  console.log(data.body.length);
                  console.log(index + 1);
                  if (index + 1 < data.body.length) {
                    nextContent = JSON.parse(
                      data.body[index + 1].messageContent
                    ).decode.paramArray;
                  }
                  item["安装地址"] = that.meterAddressName[item.messageAddress];
                  item["表具类型"] =
                    that.meterInfo[item.messageAddress].meterType;
                  item["口径"] =
                    that.meterInfo[item.messageAddress].meterCaliber;
                  item.messageTimestamp = global.dateFtt(
                    "yyyy-MM-dd hh:mm:ss",
                    new Date(item.messageTimestamp)
                  );
                  let content = JSON.parse(item.messageContent).decode
                    .paramArray;
                  // item["正向流量值"] = content["正向流量值"].value;
                  // item["反向流量值"] = content["反向流量值"].value;
                  item["正向流量值"] =
                    content["正向流量值"].value == undefined
                      ? ""
                      : Math.round(
                          (parseFloat(content["正向流量值"].value) / 1000) * 100
                        ) / 100;
                  item["反向流量值"] =
                    content["反向流量值"].value == undefined
                      ? ""
                      : Math.round(
                          (parseFloat(content["反向流量值"].value) / 1000) * 100
                        ) / 100;

                  item["热量值"] = content["热量值"].value;
                  item["冷量值"] = content["冷量值"].value;
                  item["流量值"] = content["正向流量值"].value;
                  if (nextContent) {
                    console.log(nextContent);
                    // item["正向流量间隔值"] =
                    //   content["正向流量值"].value -
                    //   lastContent["正向流量值"].value;
                    // item["反向流量间隔值"] =
                    //   content["反向流量值"].value -
                    //   lastContent["反向流量值"].value;
                    item["正向流量间隔值"] = Math.abs(
                      Math.round(
                        (parseFloat(
                          nextContent["正向流量值"].value -
                            content["正向流量值"].value
                        ) /
                          1000) *
                          100
                      ) / 100
                    );
                    item["反向流量间隔值"] = Math.abs(
                      Math.round(
                        (parseFloat(
                          nextContent["反向流量值"].value -
                            content["反向流量值"].value
                        ) /
                          1000) *
                          100
                      ) / 100
                    );
                    item["热量间隔值"] = Math.abs(
                      nextContent["热量值"].value - content["热量值"].value
                    );
                    item["冷量间隔值"] = Math.abs(
                      nextContent["冷量值"].value - content["冷量值"].value
                    );
                    item["流量间隔值"] = Math.abs(
                      nextContent["正向流量值"].value -
                        content["正向流量值"].value
                    );
                  } else {
                    // item["正向流量间隔值"] = content["正向流量值"].value;
                    // item["反向流量间隔值"] = content["反向流量值"].value;
                    // item["热量间隔值"] = content["热量值"].value;
                    // item["冷量间隔值"] = content["冷量值"].value;
                    // item["流量间隔值"] = content["正向流量值"].value;
                    item["正向流量间隔值"] = 0;
                    item["反向流量间隔值"] = 0;
                    item["热量间隔值"] = 0;
                    item["冷量间隔值"] = 0;
                    item["流量间隔值"] = 0;
                  }
                  lastContent = JSON.parse(item.messageContent).decode
                    .paramArray;
                  if (lastId != item.messageId) {
                    that.tableData.push(item);
                  }
                  lastId = item.messageId;
                  return item;
                });
                
              })
              .catch((error) => {
                that.$Notice.error({
                  title: "异常",
                  desc: error,
                });
                console.log(error);
              })
              .finally(() => {
                that.okLoading = false;
                that.showModal = false;
              });
          } else {
            this.$Notice.warning({
              title: "请选择表具！",
            });
          }
        }
      }
    },
    selectedTree(id, flag) {
      this.amendTreeData = this.treeChangeSelected(
        this.amendTreeData,
        id,
        flag
      );
    },
    treeChangeSelected(treeData, Id, flag) {
      let _this = this;
      for (var i = 0; treeData && i < treeData.length; i++) {
        if (treeData[i].children) {
          treeData[i].children = _this.treeChangeSelected(
            treeData[i].children,
            Id,
            flag
          );
        } else {
          this.$set(treeData[i], "selected", false); //重要！用set方法
          if (Id !== treeData[i].id) {
            //非当前选中设置为未选中
            this.$set(treeData[i], "checked", flag); //重要！用set方法
          } else {
            this.$set(treeData[i], "checked", !flag);
          }
        }
      }
      return treeData;
    },
    renderContent(h, { root, node, data }) {
      var that = this;
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
          },
          on: {
            dblclick: () => {
              console.log(data);
              that.checkId = data.id;
              that.meterType = data.meterType;
              that.ok();
            },
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline",
              },
              style: {
                marginRight: "8px",
              },
            }),
            h("span", data.title),
          ]),
          h(
            "span",
            {
              style: {
                display: "inline-block",
                float: "right",
                marginRight: "32px",
              },
            },
            []
          ),
        ]
      );
    },
    changeCheck(res) {
      console.log(res);
      //单选封装
      if (res.length == 0) {
        this.checkId = "";
        this.checkArr = [];
      } else if (res.length == 1) {
        this.checkId = res[0].id;
        this.checkArr = res[0];
      } else if (res.length > 1) {
        // 需获取与当前缓存不一样的id 赋值到新的id里
        if (this.checkId === "") {
          if (this.parent.pid === res[0].id) {
            this.checkId = res[1].id;
            this.checkArr = res[1];
          } else {
            this.checkId = res[0].id;
            this.checkArr = res[0];
          }
        } else if (res[0].id === this.checkId) {
          this.checkId = res[1].id;
          this.checkArr = res[1];
        } else {
          this.checkId = res[0].id;
          this.checkArr = res[0];
        }
        this.selectedTree(this.checkId, false);
      }
    },
  },
};
</script>

<style scoped>
.home-container {
  padding-top: 5px;
  height: 100%;
}

.home-content {
  height: 100%;
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}

/* 侧边栏 */
aside {
  position: fixed;
  left: 0;
  width: 90px;
  background: #f8f8f9;
  height: 100%;
  transition: width 0.3s;
  overflow: auto;
}

.aside-container {
  /* height: 100%; */
  padding: 10px;
  padding-top: 5px;
}

.aside-content {
  min-height: 100%;
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}

.aside-big {
  position: fixed;
  left: 0;
  background: #f8f8f9;
  height: calc(100% - 151px);
  transition: width 0.3s;
  overflow: auto;
  width: 300px;
}

.min-table /deep/ .ivu-table td {
  height: 0px;
}

.min-table /deep/ .ivu-table-header thead tr th {
  height: 0px;
  padding: 0px;
}

.sum-title {
  font-size: 25px;
  color: #000000;
  font-weight: 900;
}

.sum-value {
  font-size: 25px;
  color: #57a3f3;
  font-weight: 900;
}

.ivu-tree /deep/ .ivu-icon {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  display: none;
}
.ivu-tree /deep/ .ivu-icon-ios-arrow-forward:before {
  content: "";
  background-size: cover;
  width: 20px;
  height: 20px;
  display: none;
}
.ivu-tree /deep/ .ivu-checkbox-wrapper {
  display: none;
}
.ivu-tree /deep/ .ivu-checkbox-default {
  display: none;
}

.ivu-tree /deep/ .ivu-tree-arrow-open .ivu-icon-ios-arrow-forward:before {
  content: "";
  display: none;
  width: 20px;
  height: 20px;
}
.ivu-tree /deep/ .ivu-tree-children {
  white-space: pre-line !important;
  /* background-color: #ddffff!important; */
  padding: 4px;
  border-left: 6px solid #ccc !important;
  border-color: #2196f3 !important;
  margin-bottom: 2%;
  cursor: pointer;
}
.ivu-tree /deep/ li ul {
  padding: 0px;
}
</style>
